import { useApi } from '@/api';
import type { GetTopBrandsResponse } from '@/api/handlers/resources/sales/responses/GetTopBrandsResponse';
import type { ApiResponse } from '@/api/handlers/responses/ApiResponse';
import { useQuery } from '@tanstack/react-query';
import { SalesQueryKeys } from './salesQueryKeys';

export type UseTopBrandsQueryParams = {
    from: string;
    to: string;
};

/**
 * Top-brands query. The `queryKey` carries `from` / `to` so changing
 * the page-level period filter triggers a refetch automatically.
 */
export const useTopBrandsQuery = (
    params: UseTopBrandsQueryParams,
    enabled = true,
) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetTopBrandsResponse>>({
        queryKey: SalesQueryKeys.topBrands(params.from, params.to),
        queryFn: () =>
            apiClient.sales.getTopBrands({
                from: params.from,
                to: params.to,
            }),
        enabled,
        staleTime: 60_000,
    });
};
